import { render, staticRenderFns } from "./StopAdvisorPopup.vue?vue&type=template&id=580d1125&scoped=true&"
import script from "./StopAdvisorPopup.vue?vue&type=script&lang=ts&"
export * from "./StopAdvisorPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580d1125",
  null
  
)

export default component.exports